// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"NS-z","categoryName":"OS-z","categoryNameSearchHeader":"PS-z","categoryContent":"QS-z","bottomAligned":"RS-z","image":"SS-z","imageNoBackground":"TS-z"};